import { isProd } from 'consts'
import { TFunction, CustomTypeOptions } from 'i18next'

type ErrorKey = keyof CustomTypeOptions['resources']['errors']

export const getErrorMessage = (
  t: TFunction<'errors', undefined>,
  message?: string
): string | undefined => {
  if (!message) return undefined

  if (t(message as ErrorKey, { defaultValue: '' }) !== '') {
    return t(message as ErrorKey)
  }

  if (isProd) return message

  throw new Error(`Missing error translation for: "${message}"`)
}
